import { getApi } from 'apis';
import TableActionHeader from 'components/Global/TableActionHeader';
import React, { useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import CoaTable from './Table';

const CoaTables: React.FC = () => {
	const [coaData, setCoaData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [totalRecords, setTotalRecords] = useState(0);
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(10);

	useEffect(() => {
		const fetchCoaData = async () => {
			setIsLoading(true);
			try {
				const query = {
					limit,
					page,
				};
				const response = await getApi('/coa/getAllCoa', query);
				setCoaData(response.data.data);
				setTotalRecords(response.data.total);
			} catch (error: any) {
				let message =
					error?.response?.data?.message ||
					`Failed to fetch COA data`;
				toastText(message, 'error');
			} finally {
				setIsLoading(false);
			}
		};

		fetchCoaData();
	}, [page, limit]);

	const paginationChangeHandler = (pageNo: number, pageSize: number) => {
		setPage(pageNo);
		setLimit(pageSize);
	};

	return (
		<>
			<div>
				<TableActionHeader title={'Roles'} />
			</div>
			<div>
				<CoaTable
					data={coaData}
					loading={isLoading}
					paginationChangeHandler={paginationChangeHandler}
					totalRecords={totalRecords}
					currentPage={page}
				/>
			</div>
		</>
	);
};

export default CoaTables;
